define('HashtagGallery.Model', [
    'Backbone',
    'underscore',
    'Utils'
], function HashtagGalleryModel(
    Backbone,
    _
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: _.getAbsoluteUrl(getExtensionAssetsPath('HashtagGallery/services/HashtagGallery.Service.ss')) // eslint-disable-line no-undef
    });
});
